<div class="transaction-history-shell">
  <div class="container fw-b wrapper-content">
    <app-linker-route
      [headingName]="headingName"
      [linkerRouteItems]="linkerRouteItems"
    ></app-linker-route>
  </div>

  <section class="container transaction-hero">
    <div class="hero-container-card">
      <div class="hero-cards-wrapper">
        <div class="hero-stat-card total-records-card">
          <div class="card-accent-strip total-records-accent"></div>
          <div class="card-content">
            <div class="card-icon-wrapper total-records-icon">
              <i class="fa fa-list" aria-hidden="true"></i>
            </div>
            <p class="stat-amount">{{ count || 0 }}</p>
            <label class="stat-label">Total Records</label>
            <p class="stat-description">Matching the selected filter</p>
          </div>
        </div>
        <div class="hero-stat-card visible-rows-card">
          <div class="card-accent-strip visible-rows-accent"></div>
          <div class="card-content">
            <div class="card-icon-wrapper visible-rows-icon">
              <i class="fa fa-eye" aria-hidden="true"></i>
            </div>
            <p class="stat-amount">{{ orderList?.length || 0 }}</p>
            <label class="stat-label">Visible Rows</label>
            <p class="stat-description">Page {{ currentPage }} of {{ ((count || 0) / pageSize) | number : '1.0-0' }}</p>
          </div>
        </div>
        <div class="hero-stat-card campaign-type-card">
          <div class="card-accent-strip campaign-type-accent"></div>
          <div class="card-content">
            <div class="card-icon-wrapper campaign-type-icon">
              <i class="fa fa-tag" aria-hidden="true"></i>
            </div>
            <p class="stat-amount">{{ interestedPrice === 'PRODUCT' ? 'Product' : 'Service' }}</p>
            <label class="stat-label">Campaign Type</label>
            <p class="stat-description">Showing recent interested prices</p>
          </div>
        </div>
      </div>
      <div class="toggle-group-wrapper">
        <div class="toggle-group" role="tablist" aria-label="Campaign type filter">
          <button
            type="button"
            class="toggle-btn"
            [class.toggle-btn--active]="interestedPrice === 'PRODUCT'"
            (click)="tabChange('PRODUCT')"
            [attr.aria-pressed]="interestedPrice === 'PRODUCT'">
            Products
          </button>
          <button
            type="button"
            class="toggle-btn"
            [class.toggle-btn--active]="interestedPrice === 'SERVICE'"
            (click)="tabChange('SERVICE')"
            [attr.aria-pressed]="interestedPrice === 'SERVICE'">
            Services
          </button>
        </div>
      </div>
    </div>
  </section>

  <section class="container transaction-table-section">
    <article class="transaction-table-card">
      <div class="table-header">
        <div>
          <p class="section-eyebrow">{{ interestedPrice === 'PRODUCT' ? 'Product Campaigns' : 'Service Campaigns' }}</p>
          <h2>Interested price submissions</h2>
        </div>
        <span class="badge-counter">{{ interestedPrice === 'PRODUCT' ? 'Products' : 'Services' }}</span>
      </div>

      <div class="table-responsive">
        <table class="table modern-table">
          <ng-container *ngIf="interestedPrice === 'PRODUCT'; else serviceTable">
            <thead>
              <tr>
                <th scope="col">S.No</th>
                <th scope="col">Product</th>
                <th scope="col">Unit / Size</th>
                <th scope="col">Actual Price</th>
                <th scope="col">Interested Price</th>
                <th scope="col">Campaign Type</th>
                <th scope="col">Created At</th>
              </tr>
            </thead>
            <tbody>
              <tr
                *ngFor="let item of orderList | paginate:{itemsPerPage:pageSize, currentPage: currentPage,totalItems: count}; let i=index; "
              >
                <td data-label="S.No">{{10 * (currentPage - 1) + i+1}}</td>
                <td data-label="Product">
                  <div class="product-cell">
                    <img class="imagtag" [src]="item?.productId?.thumbnail" alt="">
                    <div>
                      <p class="cell-title">{{item?.productId?.productName || '--'}}</p>
                      <p class="cell-subtitle">{{ item?.productId?.categoryId?.categoryName || 'Uncategorised' }}</p>
                    </div>
                  </div>
                </td>
                <td data-label="Unit / Size">{{ item?.priceSizeDetails?.value }} {{ item?.priceSizeDetails?.unit !== 'other' ? item?.priceSizeDetails?.unit : '' }}</td>
                <td data-label="Actual Price">{{item?.priceSizeDetails?.price ? getPrice(item?.priceSizeDetails?.price | currency:"ZAR":"R") : '--'}}</td>
                <td data-label="Interested Price">{{item?.interestedPrice ?  getPrice(item?.interestedPrice | currency:"ZAR":"R") : '--'}}</td>
                <td data-label="Campaign Type">{{ item?.spordicType || '--' }}</td>
                <td data-label="Created At">{{item?.createdAt | date: 'yyyy-MM-dd h:mm:ss a' || '--'}}</td>
              </tr>
            </tbody>
          </ng-container>

          <ng-template #serviceTable>
            <thead>
              <tr>
                <th scope="col">S.No</th>
                <th scope="col">Service</th>
                <th scope="col">Booking Category</th>
                <th scope="col">Booking Name</th>
                <th scope="col">Actual Price</th>
                <th scope="col">Interested Price</th>
                <th scope="col">Campaign Type</th>
                <th scope="col">Created At</th>
              </tr>
            </thead>
            <tbody>
              <tr
                *ngFor="let item of orderList | paginate:{itemsPerPage:pageSize, currentPage: currentPage,totalItems: count}; let i=index; "
              >
                <td data-label="S.No">{{10 * (currentPage - 1) + i+1}}</td>
                <td data-label="Service">
                  <div class="product-cell">
                    <img class="imagtag" [src]="item?.serviceId?.userId?.profilePic" alt="">
                    <div>
                      <p class="cell-title">{{ item?.serviceId?.serviceName || '--' }}</p>
                      <p class="cell-subtitle">{{ item?.serviceId?.userId?.businessName || 'Freelancer' }}</p>
                    </div>
                  </div>
                </td>
                <td data-label="Booking Category">{{item?.serviceId?.categoryId?.categoryName || '--'}}</td>
                <td data-label="Booking Name">{{item?.serviceId?.serviceName || '--'}}</td>
                <td data-label="Actual Price">{{item?.serviceId?.price ? getPrice(item?.serviceId?.price | currency:"ZAR":"R") : '--'}}</td>
                <td data-label="Interested Price">{{item?.interestedPrice ?  getPrice(item?.interestedPrice | currency:"ZAR":"R") : '--'}}</td>
                <td data-label="Campaign Type">{{ item?.spordicType || '--' }}</td>
                <td data-label="Created At">{{item?.createdAt | date: 'yyyy-MM-dd h:mm:ss a' || '--'}}</td>
              </tr>
            </tbody>
          </ng-template>
        </table>
      </div>


      <app-table-loader
        *ngIf="isLoading || (!isLoading && (!orderList || orderList.length === 0))"
        [isTable]="'TABLE'"
        [isLoading]="isLoading"
        [notFoundData]="!isLoading && (!orderList || orderList.length === 0)"
        [colspan]="interestedPrice === 'PRODUCT' ? 7 : 8"
        [isWidth]="'55px'"
      >
      </app-table-loader>

      <div class="transaction-table-footer" *ngIf="count > 10">
        <pagination-controls (pageChange)="changePageNumber($event)"></pagination-controls>
      </div>
    </article>
  </section>
</div>